import { FormEvent, useState } from 'react'
import cx from 'classnames'
import { App } from 'antd'
import { MEDIATEKA_DOWNLOAD } from '@/constants/urls'
import { IRange, IMadText, IMadImage, IAnswer, IAnswerWithImage } from '@/models'
import { Button, Row, Text } from '@/components/ui'
import s from './question-types.module.scss'

interface IMadRangeQuestionProps {
  question: IRange & IMadText & IMadImage
  sendQuestion?: (data: any) => void
  updateMadRangeQuestion?: (data: any) => void
}

const MadRangeQuestion = ({ question, sendQuestion, updateMadRangeQuestion }: IMadRangeQuestionProps) => {
  const [selectedAnswers, setSelectedAnswers] = useState<IAnswer[] | []>([])
  const { message } = App.useApp()

  const onChooseAnswer = (answer: IAnswer & IAnswerWithImage) => {
    const answerObject = selectedAnswers.find((v: IAnswer) => v?.uuid === answer.uuid)

    if (!answerObject) {
      setSelectedAnswers((prev: IAnswer[]) => [...prev, { ...answer }])
    }
  }

  const updateMadRangeQuestionPositions = (rangeSelect: any) => {
    const copyQuestion = JSON.parse(JSON.stringify(question))
    const updatedQuestionWithUserRange = {
      ...copyQuestion,
      answers_objects: copyQuestion.answers_objects.map((v: IAnswer) => ({
        ...v,
        userPositionSelected: rangeSelect.find((vv: any) => vv.answer_object_uuid === v.uuid)?.position_value
      }))
    }

    if (typeof updateMadRangeQuestion === 'function') {
      updateMadRangeQuestion(updatedQuestionWithUserRange)
    }
  }

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (selectedAnswers?.length === question.answers_objects.length) {
      const data = {
        range_select: selectedAnswers.map((v: IAnswer, i: number) => ({
          answer_object_uuid: v.uuid,
          position_value: question.position_values[i]
        }))
      }

      if (sendQuestion) {
        sendQuestion(data)
      }
      updateMadRangeQuestionPositions(data.range_select)
    } else {
      message.error('Пронумеруйте все варианты ответа')
    }
  }

  const isSelected = (answerId: string): boolean => selectedAnswers.some((v: IAnswer) => v.uuid === answerId)

  const getOrderNumber = (answerId: string): number =>
    selectedAnswers.findIndex((v: IAnswer) => v.uuid === answerId) + 1

  return (
    <div className={cx(s['question-wrapper'], s['range-question'])}>
      <form className={s.question} onSubmit={onSubmit}>
        <Button
          view='primary'
          color='red'
          className={s['question__reset-button']}
          onClick={() => setSelectedAnswers([])}
          disabled={selectedAnswers.length === 0}
        >
          Сбросить порядок
        </Button>
        <Row row={20} className={s['answers-list']}>
          {question.answers_objects.map((answer: any) => (
            <div key={answer.uuid} className={s['answers-list__item']} onClick={() => onChooseAnswer(answer)}>
              <Text>{answer.title}</Text>
              {answer?.image_id && (
                <div className={s.image}>
                  <img src={`${MEDIATEKA_DOWNLOAD}/${answer.image_id}`} alt='Изображение объекта ранжирования' />
                </div>
              )}
              {isSelected(answer.uuid) && <div className={s.badge}>{getOrderNumber(answer.uuid)}</div>}
            </div>
          ))}
        </Row>
        <Button className={s['question__next-button']} type='submit'>
          Продолжить
        </Button>
      </form>
    </div>
  )
}

export default MadRangeQuestion
